export default __webpack_public_path__ + "static/media/mu.e6ff5cfd.svg";